import { useTranslation } from "react-i18next";
import { ModalCloseButton } from "../../atoms/StationModal/StationFeeds";
import { NewChildPopupBG, NewChildPopupWrapper } from "../FeedsPopup";
import { Text } from "../../atoms/TextField";
import { CookieSettingsWrapper, CookieWrapper, SaveCookies } from "../MyAccountView";
import Toggle from "../../molecule/Toggle";import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { isMobile } from "../../../utilities/deviceUtilities";
import { gaEvent } from "../../../utilities/analytics";
import { constants } from "../../../constants";
import { logoutUser } from "../../../utilities/LogOutUtils";
import * as LogoutAction from "@mywvglobal-shared/mywv-shared/action/persistItemsAction";
import useApiRepository from "../../../api/useApiRepository";

function CookiesPopup(props) {
    const { t } = useTranslation();
    const [analyticCookiesStatus, setAnalyticCookiesStatus] = useState(true);
    const dispatch = useDispatch();
    const { getCookiePreferenceReducer } = useSelector((state) => state);
    const { persistItemsReducer } = useSelector((state) => state);
    const { loginReducer } = useSelector((state) => state);
    const apiRepo = useApiRepository();

    const toggleSwitch = () => {
        setAnalyticCookiesStatus(!analyticCookiesStatus);
        gaEvent("CookieSettingPopupAnalyticsToggleBtn", persistItemsReducer);
    }

    useEffect(() => {
        if (!props?.loginPage) {
            apiRepo.getCookiePreference();
        }
    }, []);

    useEffect(() => {
        (!props?.loginPage) &&
            setAnalyticCookiesStatus(getCookiePreferenceReducer?.getCookiePreference?.cookiesPreferenceEnabled);
    }, [getCookiePreferenceReducer]);

    const handleSave = () => {
        gaEvent("CookieSettingPopupSaveSettingBtn", persistItemsReducer);
        if (!props?.loginPage) {
            apiRepo.updateCookiePreference(analyticCookiesStatus);
        }
        props?.closeBtnClick(false)
    }

    async function handleUnauthorizedTokenError() {
        await logoutUser({
            persistItemsReducer, loginReducer, dispatch,
            LogoutAction, constants,
        });
    }

    useEffect(() => {
        // if token is expired or unauthorized, logout user
        if (getCookiePreferenceReducer.errorMessage?.status === 401) {
            handleUnauthorizedTokenError()
            return
        }
    }, [getCookiePreferenceReducer?.errorMessage?.status]);

    return (
        <>
            <NewChildPopupBG
                show={props.show}
                onClick={() => { props?.closeBtnClick(false) }}
            />
            <NewChildPopupWrapper zindex="11" width={isMobile() ? "80%" : "56%"} height="auto" maxheight="65%" >
                <ModalCloseButton onClick={() => { props?.closeBtnClick(false); gaEvent("CookieSettingPopupCloseBtn", persistItemsReducer) }} />
                <CookieSettingsWrapper>
                    <Text updateProfile>{t("cookieSettingsTitle")}</Text>
                    <Text cookiesmsg>{t("cookieSettingsDescription")}</Text>
                    <Text cookieSub>{t("necessarySettingsTitle")}</Text>

                    <CookieWrapper necessary>
                        <Text cookiesmsg>{t("necessarySettingsDescription")}</Text>
                        <Toggle marginLeft="3vw" marginRight="3vw" value={true} disabled onToggle={() => { }} />
                    </CookieWrapper>

                    <Text cookieSub>{t("analyticsSettingsTitle")}</Text>

                    <CookieWrapper>
                        <Text cookiesmsg>{t("analyticsSettingsDescription")}</Text>
                        <Toggle marginLeft="3vw" marginRight="3vw" value={analyticCookiesStatus} onToggle={toggleSwitch} />
                    </CookieWrapper>

                    <SaveCookies onClick={() => handleSave()}>
                        <span>{t("cookieSettingsSubmit")}</span>
                    </SaveCookies>
                </CookieSettingsWrapper>
            </NewChildPopupWrapper>
        </>
    );
}

export default CookiesPopup;